// extracted by mini-css-extract-plugin
module.exports = {"infoMessageContainer":"InfoText_infoMessageContainer__cd1jN","infoMessageText":"InfoText_infoMessageText__1r98j"};